module.exports = __webpack_public_path__ + "static/media/r5-1.8a6db406.png";